import React from 'react';
import { Box } from '@mui/material';
import { FooterContainer, SelectionText, ActionButton, ClearButton, ActionsContainer } from './styles';
import { TableFooterProps } from './types';

const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const TableFooter: React.FC<TableFooterProps> = ({
  selectedCount,
  totalCount,
  actions,
  clearAllText = 'Clear all',
  selectedText = 'selected',
  ofText = 'of',
  canClearAll = true,
  onClearSelection,
  extraText,
  selectedCountTestId,
}) => {
  return (
    <FooterContainer>
      <SelectionText data-testid={selectedCountTestId}>
        {selectedCount} {selectedText}
      </SelectionText>

      {canClearAll && onClearSelection && (
        <ClearButton onClick={onClearSelection} aria-label="Clear selection">
          {clearAllText}
        </ClearButton>
      )}

      <ActionsContainer>
        {actions.map(action => (
          <ActionButton
            key={action.id}
            onClick={action.onClick}
            aria-label={action.ariaLabel || action.label}
            title={action.title || action.label}
            data-testid={action.testId}
          >
            <Box className="icon-circle">{action.icon}</Box>
            <span>{action.label}</span>
          </ActionButton>
        ))}
      </ActionsContainer>
    </FooterContainer>
  );
};
